import {
  Box,
  Container,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  styled,
} from "@mui/material";
import VariantBox from "../components/variant-box";
import { useState } from "react";
import { createApiCall } from "../api/api-service";
import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import BreadCrumbComp from "../components/breadcrumb";
import ErrorIcon from "@mui/icons-material/Error";
import DialogBox from "../components/dialog-box";
import ProductMainImage from "../components/product-main-image";
import CommonLabel from "../components/label";
import RetailorPrice from "../components/retailor-price";
import LineChart from "../components/Charts/line-chart";
import theme from "../theme";
import VideoCarousel from "../components/Carousel/video-carousel";
import CommonCarousel from "../components/Carousel/common-carousel";
import YoutubeInlinePlayer from "../components/Carousel/youtube-carousel";
import InstagramInlineEmbed from "../components/Carousel/instagram-carousel";
import ProductCarousel from "../components/Carousel/product-carousel";
import { AssistWalkerOutlined } from "@mui/icons-material";

const GradientButton = styled(IconButton)(({ theme }) => ({
  background: `linear-gradient(60deg,${theme.palette.primary.main},${theme.palette.secondary.main})`,
}));

const ProductPage = () => {
  const { product } = useParams();
  const [openPopup, setOpenPopUp] = useState(false);
  const [ecomStoreListExpanded, setEcomStoreListExpanded] = useState(false);
  
  const fetchProductData = async () => {
    if (!product) throw new Error("Product ID is required");
    const data = await createApiCall("POST", "inventory/fetch_product_info", {
      variant_id: product,
    });
    if (!data) throw new Error("Failed to fetch product data");
    return data;
  };

  const fetchExploreData = async () => {
    console.log(product)
    const data = await createApiCall("POST", "inventory/fetch_product_explore_product", { variant_id: product })
    return data || [];
  }
  const {
    data: productDetail,
    isLoading: isProductLoading,
    isError: isProductError,
    error: productError,
  } = useQuery({
    queryKey: ["product", product],
    queryFn: fetchProductData,
    staleTime: 10 * 60 * 1000,
    retry: 1,
  });
  const {
    data: productExploreDetail,
    isLoading: isProductExploreLoading,
    isError: isProductExploreError,
    error: productExploreError,
  } = useQuery({
    queryKey: ["product", "explore", product],
    queryFn: fetchExploreData,
    staleTime: 10 * 60 * 1000,
    retry: 1,
  });



  // Derive data from query result
  const historicData = productDetail
    ? {
      summary_data: productDetail?.historical_summary_data,
      data: productDetail?.historical_data,
    }
    : {};

  const contentList = productDetail?.social_media_content || [];
  const allEcomStores = productDetail?.ecommerce_info || [];
  const ecomStoreList = ecomStoreListExpanded
    ? allEcomStores
    : allEcomStores.slice(0, 3);

  const BreadCrumbList = productDetail ? [product] : [];
  const flagUrl = `https://flagsapi.com/${productDetail?.variant_origin_code}/flat/32.png`

  if (isProductLoading) {
    return <>Loading .....</>;
  }

  if (isProductError) {
    return (
      <Container sx={{ marginTop: "10px", textAlign: "center" }}>
        <Typography color="error">Failed to load product data</Typography>
        {productError && (
          <Typography variant="body2" color="textSecondary">
            {productError.message}
          </Typography>
        )}
      </Container>
    );
  }

  if (!productDetail) {
    return <>Loading .....</>;
  }
  return (
    <>
      <Container sx={{ marginTop: "10px", overflowX: "hidden" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: "10px",
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", md: "400px" },
              maxWidth: "100%",
              flexShrink: 0,
            }}
          >
            <ProductMainImage
              src={productDetail?.variant_image}
              width={"100%"}
              height={"100%"}
              style={{ maxWidth: "400px", maxHeight: "400px" }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              marginTop: "25px",
              width: "100%",
              gap: "10px",
            }}
          >
            {productDetail?.variant_origin !== "" ?
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <img src={flagUrl} />
                <CommonLabel
                  variant={"body2"}
                  sx={{ color: "grey", fontSize: "1rem" }}
                >
                  {" "}
                  Origin:{" "}
                  <span style={{ fontWeight: "bold", color: "black" }}>
                    {" "}
                    {productDetail?.variant_origin}
                  </span>{" "}
                </CommonLabel>
              </Box>
              : <></>}
            <CommonLabel
              variant={"h4"}
              sx={{ fontWeight: "bold", fontSize: { xs: "1.25rem", sm: "1.6rem", md: "2rem" } }}
            >
              {" "}
              {productDetail?.variant_name.length > 100
                ? productDetail?.variant_name.slice(0, 100) + " ..."
                : productDetail?.variant_name}
            </CommonLabel>

            <CommonLabel
              variant={"body2"}
              sx={{ color: "grey", fontSize: "1rem" }}
            >
              {" "}
              Brand:{" "}
              <span style={{ fontWeight: "bold", color: "black" }}>
                {" "}
                {productDetail?.brand_name}{" "}
              </span>{" "}
            </CommonLabel>

            <Box>
              <CommonLabel>Compare price</CommonLabel>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "10px" }}
              >
                {ecomStoreList.map((retailer, index) => {
                  console.log(index);
                  return (
                    <RetailorPrice
                      key={index}
                      retailerData={retailer}
                      otherinfo="Lowest"
                    />
                  );
                })}
                {(allEcomStores.length > 3 && !ecomStoreListExpanded) ? <CommonLabel variant={'body2'} sx={{ color: '#F857A6', cursor: 'pointer' }} onClick={() => { setEcomStoreListExpanded(true) }} > +{allEcomStores.length - 3} More Stores </CommonLabel> : <></>}
              </Box>
            </Box>
          </Box>
        </Box>
        {/* 
        <Box sx={{mt:'10px'}}>
          <LineChart
            data={historicData["data"]}
            defaultRetailer="Flipkart"
            defaultRange="1W"
            summaryData={historicData["summary_data"]}
          />
        </Box>
        */}
        {/*  {contentList && (
          <Box
            sx={{
              background: theme.palette.primary.main500,
              width: "99%",
              height: "100%",
              padding: "20px",
              marginTop:'10px'
            }}
          >
           <Box sx={{ background: theme.palette.primary.main100 }}>
              <CommonCarousel>
                {contentList.map((item, index) => {
                  return <YoutubeInlinePlayer url={item?.content_url} />;
                })}
              </CommonCarousel>

              {/* <CommonCarousel>
             <InstagramInlineEmbed/>
            </CommonCarousel> 
          // </Box>
           
          </Box>
        )}*/}
        {/* <VideoCarousel/> */}
        <ProductCarousel label="Explore More Products" products={productExploreDetail || []} onProductClick={(product) => console.log("Clicked")} />
      </Container>

      {/* <Box sx={{marginLeft:'10px'}} >

    <BreadCrumbComp itemList={BreadCrumbList} />
    </Box> */}
      {/* <Container
        maxWidth={false}
        sx={{
          display: "flex",
          flexDirection: { xs: "column", ms: "row", lg: "row" },
          alignItems: "center",
          paddingTop: "10px",
        }}
      >
        
        <Box
          sx={{
            width: { xs: "90%", ms: "90%", lg: "35%" },
            height: "350px",
            borderRadius: "10px",
            position:'relative'
          }}
        >
          <img
            src={productDetail?.variant_image}
            width={"100%"}
            height={"100%"}
            style={{ borderRadius: "10px" }}
          />
          {/* <Box
            sx={{
              position: "absolute",
              bottom: 16,
              right:9,
              bgcolor: "rgba(255, 255, 255, 0.8)", // White with opacity
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 2, // Material-UI border-radius
              boxShadow: 3, // Material-UI shadow
      
            
            }}
          >
            <img
              src={India}
              alt="Indian Flag"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                 // Use theme's border radius
              }}
            />
          </Box> */}
      {/* </Box>

        <Box sx={{ marginTop: "10px" }}>
          <Box sx={{ marginTop: "10px" }}>
            {/* Color Variant */}

      {/* <Box sx={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        {productDetail?.variant_info.map((variant, index) => {
          return (
            <VariantBox
              imgurl={variant?.variant_image}
              variant_name={variant?.variant_name}
              url={`/product/${variant?.variant_url}`}
            />
          );
        })}
      </Box> */}
      {/* Product Title and color variant */}
      {/* <Typography
        variant="h1"
        fontSize={"1.5rem"}
        fontWeight={"bold"}
        sx={{ marginTop: "10px" }}
      >
        {productDetail?.variant_name}
      </Typography> */}
      {/* <Typography
              variant="body2"
              sx={{ color: "#11111199", marginTop: "10px" }}
            >
              {productDetail?.variant_desc.length > 100
                ?
                productDetail?.variant_desc.slice(0, 100)                 
                : productDetail?.variant_desc}
            </Typography> */}

      {/* <Box marginTop={"10px"}>
              {/* price Component */}

      {/* <Table>
                <TableBody>
                  {productDetail?.ecommerce_info.map((ecom, index) => {
                    return (
                      <TableRow sx={{ borderBottom: "1px solid" }}>
                        <TableCell variant="body" align="left"  size="small">
                          <Typography
                            variant="body2"
                            fontWeight={"bold"}
                            fontSize={"1rem"}
                            gutterBottom
                          >
                            {ecom.ecommerce_name.toUpperCase()}
                          </Typography>
                        </TableCell>
                        <TableCell
                          variant="body"
                          align="right"
                          fontWeight={"bold"}
                          size="medium"
                        >
                          <Link
                            to={ecom?.affiliate_url}
                            style={{ textDecoration: "none" }}
                            target="_blank"
                          >
                            <GradientText >
                              <span>          {ecom.ecommerce_price}                              </span>
                            <ArrowOutwardIcon             sx={{ color: "#F857A6" }}          fontSize="1rem"  />
                            </GradientText>
                         
                          </Link>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>  */}
      {/* Report An Issue button*/}

      {/* <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',marginTop:'10px',color:'#ee0c0c'}} onClick={()=>{setOpenPopUp(true)}}> 
              
                 <ErrorIcon/>
              <Typography>
                  &nbsp;Report An Issue</Typography>
             </Box> */}
      {/* TODO: ADD Similar Product Box */}
      {/* <GradientBox header="Simmilar Product in other Brand">

                        </GradientBox> */}

      {/* <Accordion
              sx={{
                marginTop: "10px",
                maxHeight: "200px",
                overflowY: "scroll",
                scrollbarWidth: "none",
              }}
            >
              <AccordionSummary
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography component="span">Product Details</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{productDetail?.variant_desc}</Typography>
              </AccordionDetails>
            </Accordion> */}
      {/* </Box>
        </Box>
        <DialogBox open={openPopup} pageUrl={product} closePopup={setOpenPopUp}/>

        
      </Container> */}
    </>
  );
};

export default ProductPage;
